import SettingProperties from "../../../../contents/docs/integrate/send-events/_snippets/setting-properties-text.mdx";
import NamingTip from "../../../../contents/docs/integrate/send-events/_snippets/naming-tip.mdx";
import SchemaTip from "../../../../contents/docs/integrate/send-events/_snippets/schema-tip.mdx";
import Intro from "../../../../contents/docs/integrate/send-events/_snippets/intro.mdx";
import * as React from 'react';
export default {
  SettingProperties,
  NamingTip,
  SchemaTip,
  Intro,
  React
};